/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BerufInputs */

const de__field_beruf = /** @type {(inputs: _Field_BerufInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beruf`)
};

/**

* @param {_Field_BerufInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_beruf = /** @type {((inputs?: _Field_BerufInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BerufInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_beruf(inputs)
});